import $ from 'jquery';
import SidebarState from 'app/scripts/view-models/sidebar-state';
import { useEffect } from 'react';
// @ts-ignore
import { Events } from '@trello/backbone';

function updatePinnedDrawer() {
  $('#trello-root').toggleClass(
    'body-pinned-drawer',
    SidebarState.getPinSidebar(),
  );
}

export const usePinnedBoardsMenu = () => {
  useEffect(() => {
    updatePinnedDrawer();
    Events.listenTo(
      SidebarState,
      'change:pinBoardsListSidebar',
      updatePinnedDrawer,
    );

    return () => {
      Events.stopListening(
        SidebarState,
        'change:pinBoardsListSidebar',
        updatePinnedDrawer,
      );
    };
  }, []);
};
